import * as actionTypes from './../_actions/actionTypes';

const initialState = {
    loading: false,
    msgError: null,
    bookingBar: false,
    saveOnModal: false
}

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UI_SET_ERROR:
            return {
                ...state,
                msgError: action.payload
            }
        case actionTypes.UI_REM_ERROR:
            return {
                ...state,
                msgError: null
            }
        case actionTypes.UI_START_LOADING:
            return {
                ...state,
                loading: true
            }
        case actionTypes.UI_FINISH_LOADING:
            return {
                ...state,
                loading: false
            }
        case actionTypes.UI_SHOW_BOOKING_BAR:
            return {
                ...state,
                bookingBar: true
            }
        case actionTypes.UI_HIDE_BOOKING_BAR:
            return {
                ...state,
                bookingBar: false
            }
        case actionTypes.UI_SHOW_NAV_BAR:
            return {
                ...state,
                navBar: true
            }
        case actionTypes.UI_HIDE_NAV_BAR:
            return {
                ...state,
                navBar: false
            }
        case actionTypes.UI_SHOW_SAVE_ON_MODAL:
            return {
                ...state,
                saveOnModal: true
            }
        case actionTypes.UI_HIDE_SAVE_ON_MODAL:
            return {
                ...state,
                saveOnModal: false
            }
        default:
            return state;
    }
}